var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.activeIndex == 'platform')?_c('div',[_vm._m(0)]):_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"text-center bottom-text"},[_vm._v(" Copyright@smheee.com, All Rights Reserved. Email : shengming_tech@163.com Tel: 020-31802914 ")])])
}]

export { render, staticRenderFns }